import { AutopiloteVsl } from '@/components/vsl/AutopiloteVsl';

// Envoyée aux prospects qui n'ont pas encore pris rendez-vous
export default function PresentationAutopilotePage() {
  return <AutopiloteVsl variant="invitation" />;
}
